import { DebugPanel } from '@design/components/debug-panel/DebugPanel'
import { Error404Screen } from '@design/components/screens/error-404-screen/Error404Screen'
import { Toaster } from '@design/ui/sonner'
import type { QueryClient } from '@tanstack/react-query'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'

export type AppRouterContext = {
  queryClient: QueryClient
}

function AppRootLayout() {
  return (
    <>
      <Outlet />
      <Toaster />
      {import.meta.env.MODE === 'dev' && <DebugPanel />}
    </>
  )
}

export function createAppRootRoute(rootUrl: string) {
  return createRootRouteWithContext<AppRouterContext>()({
    component: AppRootLayout,
    notFoundComponent: () => <Error404Screen rootUrl={rootUrl} />,
  })
}
